import config from '@/config'
const { plugin } = config

export default (Vue) => {
  for (let name in plugin) {
    const value = plugin[name]
    if(value === false) continue  
    const path = value.path || `${name}.js`
    Vue.use(require(`./PluginManager/${path}`).default, typeof value === 'object' ? value : undefined)
  }
}
